import { LpCtaForm } from "routes/LandingPage/components/LpCtaForm";
import { LpFaq } from "routes/LandingPage/components/LpFaq";
import { LpFeatures } from "routes/LandingPage/components/LpFeatures";
import { LpFloatingCta } from "routes/LandingPage/components/LpFloatingCta";
import { LpFooter } from "routes/LandingPage/components/LpFooter";
import { LpHero } from "routes/LandingPage/components/LpHero";
import { LpMeta } from "routes/LandingPage/components/LpMeta";
import { LpNavbar } from "routes/LandingPage/components/LpNavbar";
import { LpPricing } from "routes/LandingPage/components/LpPricing";
import { LpProblem } from "routes/LandingPage/components/LpProblem";
import { LpSecurity } from "routes/LandingPage/components/LpSecurity";
import { LpSolution } from "routes/LandingPage/components/LpSolution";
import {
  type LpConfigContextValue,
  LpConfigProvider,
} from "routes/LandingPage/LpConfigContext";
import { lpDeliveryConfig } from "routes/LandingPageDelivery/lpDeliveryConfig";
import "routes/LandingPage/lp.css";

const DELIVERY_LP: LpConfigContextValue = {
  page: "delivery",
  config: lpDeliveryConfig,
};

/**
 * StrixSearch 配信 LP（/lp/delivery）
 *
 * 検索 LP と同じ部品を、配信 LP の設定（lp-config-delivery.yml）で描く。
 * 検索 LP だけの部品（LogoBand / Impact / RoiCalculator / Testimonials / ComparisonTable / Onboarding）は使わない。
 * S8「数字の出し方」は LpSecurity を計測の識別子 "measurement" で使う。
 * @return {JSX.Element} 配信 LP ページ全体
 */
const LandingPageDelivery = () => {
  return (
    <LpConfigProvider value={DELIVERY_LP}>
      <div className="lp-page min-h-screen bg-white text-[#0F1649] overflow-x-hidden">
        <LpMeta />

        <LpNavbar />
        <main>
          <LpHero />
          <LpProblem />
          <LpSolution />
          <LpFeatures />
          <LpSecurity sectionId="measurement" />
          <LpPricing />
          <LpFaq />
          <LpCtaForm />
        </main>
        <LpFooter />

        {/* Floating Mobile CTA */}
        <LpFloatingCta />
      </div>
    </LpConfigProvider>
  );
};

export default LandingPageDelivery;
